define('v3/Common/Bindings/Select.Binding',['jquery', 'knockout', 'select2'], function ($, ko) {
	var defaults = {
		minimumResultsForSearch: Infinity
	};

	ko.bindingHandlers.select = {
		init: function (element, valueAccessor) {
			var options = $.extend({}, defaults, valueAccessor());
			options.dropdownParent = options.dropdownParent || $(element).parent('dropdown').parent() || $(element).parent();
			var bindingDisabled = valueAccessor().disabled;

			var formatTemplate = function (option) {
				if (option.element) {
					if (option.element.tagName === 'OPTGROUP') {
						return option.text;
					}

					var item = $(option.element).data('item');
					var elm = document.getElementById(this);
					var className = elm.getAttribute('data-class') || 'row';
					var $state = $('<div class="' + className + '">' + elm.innerHTML + '</div>');

					if (item) {
						item.id = item.id || '';

						ko.applyBindings(item, $state[0]);
						ko.cleanNode($state[0]);
					}
				}

				return $state;
			};

			if (options.template) {
				options.templateResult = formatTemplate.bind(options.template);
			}

			if (options.templateSelection) {
				options.templateSelection = formatTemplate.bind(options.templateSelection);
			}

			if (ko.isObservable(bindingDisabled)) {
				bindingDisabled.subscribe(function (newValue) {
					var oldvalue = $(element).prop('disabled');

					if (oldvalue === newValue) { return; }

					$(element).prop('disabled', !!(newValue));
				});

				options.disabled = bindingDisabled();
			}

			$(element)
				.select2(options)
				.parent('dropdown')
				.addClass('initialized');

			if (options.minimumResultsForSearch === Infinity) {
				// Fixes PBI #12233
				// If minimumResultsForSearch is Infinity, then remove events and detach the input field.
				// This is because Google Chrome will autofill the input field, and select2 keeps filtering,
				// even when it should be disabled.
				if ($(element).data('select2').dropdown.$search) {
					$(element).data('select2').dropdown.$search.val(null).off().detach();
				}
			}

			$(element).on('select2:close', function () {
				// Fixes BUG #28040
				// Select2 will add a scroll event when it opens, however after
				// closing the dropdown it loses context of '.scrollable-right'
				// which results that the scrollbar is unable to scroll
				var $scrollableRight = $(element).parents('.scrollable-right');
				if ($scrollableRight.length > 0) {
					$scrollableRight.off('scroll.select2');
				}
			});

			ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
				if ($(element).data('select2')) {
					$(element).select2('destroy');
				}

				$(element).off('select2:close');

				if (bindingDisabled && bindingDisabled.dispose) bindingDisabled.dispose();
			});
		},
		update: function (element, valueAccessor, allBindingsAccessor) {
			var allBindings = allBindingsAccessor();
			ko.unwrap(allBindings.value);
			ko.unwrap(allBindings.selectedOptions);

			var select2 = $(element).data('select2');
			select2.dataAdapter.current(function (currentData) {
				select2.trigger('selection:update', {
					data: currentData
				});
			});
		},
		after: ['options', 'value', 'selectedOptions']
	};
});
